document.addEventListener('DOMContentLoaded', function() {
function applyFixStyles() {
    // Delay to wait for submenu animation to complete
    setTimeout(function() {
      var inner = document.querySelector('.mobile-facets__inner');
      var footer = document.querySelector('.mobile-facets__footer');
      var wrapper = document.querySelector('.mobile-facets__wrapper');

      if (wrapper) {
        wrapper.style.cssText = 'display:flex !important; flex-direction:column !important; height:100% !important; overflow:hidden !important;';
      }

      if (inner) {
        inner.style.cssText = 'flex:1 !important; min-height:0 !important; overflow:hidden !important; display:flex !important; flex-direction:column !important;';
      }

      var submenus = document.querySelectorAll('.mobile-facets__submenu');
      submenus.forEach(function(el) {
        el.style.cssText = 'overflow-y:auto !important; flex:1 !important; min-height:0 !important; -webkit-overflow-scrolling:touch !important; visibility:visible !important; height:auto !important;';
      });

      if (footer) {
        footer.style.cssText = 'flex-shrink:0 !important; background:white !important; z-index:10 !important;';
      }
    }, 400); // Wait 400ms for animation
  }



  // Watch for body class AND DOM changes (handles Clear button re-render)
  var observer = new MutationObserver(function() {
    if (document.body.classList.contains('overflow-hidden-mobile')) {
      applyFixStyles();
    }
  });

  observer.observe(document.body, { 
    attributes: true, 
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
});
